export const INPUT_SCALE = 3;
export const DISPLAY_SCALE = 2;
